import { render } from "./PageIndex.vue?vue&type=template&id=5b65a28b&scoped=true"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"

import "./PageIndex.vue?vue&type=style&index=0&id=5b65a28b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b65a28b"]])

export default __exports__